var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        _vm.getComp.comp1,
        _vm._b(
          {
            tag: "component",
            class: ["soli-round"],
            attrs: { "content-class": "soli-round", attach: _vm.attach },
            on: {
              "click:outside": function ($event) {
                !_vm.permanent ? _vm.reset(true) : null
              },
            },
            model: {
              value: _vm.dialog,
              callback: function ($$v) {
                _vm.dialog = $$v
              },
              expression: "dialog",
            },
          },
          "component",
          { ..._vm.getComp.props1 },
          false
        ),
        [
          _c(
            "v-card",
            { class: ["soli-round", _vm.flat ? "v-card--flat" : null] },
            [
              _vm.persistent
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-3 soli-close",
                      attrs: { icon: "" },
                      on: { click: _vm.reset },
                    },
                    [_c("v-icon", [_vm._v("clear")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-title",
                { staticClass: "soli-grey" },
                [
                  _vm.backButton
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mr-3",
                          staticStyle: { "margin-left": "-12px" },
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              ;[_vm.$emit("backAction"), _vm.reset(true)]
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("chevron_left")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.title)),
                ],
                1
              ),
              _vm._v(" "),
              _vm.subtitle
                ? _c("v-card-subtitle", {
                    staticClass: "soli-grey pa-6 pb-0",
                    class: { "font-weight-bold": _vm.bold },
                    domProps: { innerHTML: _vm._s(_vm.subtitle) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.subtitle
                ? _c(
                    "div",
                    {
                      staticClass: "pa-3",
                      staticStyle: {
                        "max-height": "400px",
                        "overflow-y": "auto",
                      },
                    },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.textOnly
                ? _c(
                    "div",
                    [
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: ["pa-3", _vm.left ? null : "flex justify-end"],
                        },
                        [
                          _vm.button2
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "soli-round",
                                  attrs: {
                                    color: _vm.warning ? "primary" : "dark",
                                    loading: _vm.showLoading2,
                                    text: "",
                                    block: _vm.left,
                                    disabled: _vm.disabled2,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$emit("option2"),
                                        _vm.loading2
                                          ? (_vm.showLoading2 = true)
                                          : _vm.reset(false)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.button2) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.button3
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "soli-round",
                                  attrs: {
                                    color: _vm.button3Color,
                                    loading: _vm.showLoading3,
                                    text: "",
                                    block: _vm.left,
                                    disabled: _vm.disabled3,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$emit("option3"),
                                        _vm.loading3
                                          ? (_vm.showLoading3 = true)
                                          : _vm.reset(false)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.button3) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.button1
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "soli-round",
                                  attrs: {
                                    loading: _vm.showLoading1,
                                    color:
                                      _vm.warning || _vm.warning1
                                        ? "error"
                                        : "primary",
                                    disabled: _vm.disabled1,
                                    text: "",
                                    block: _vm.left,
                                    href: _vm.link1 ?? null,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$emit("option1"),
                                        _vm.loading1
                                          ? (_vm.showLoading1 = true)
                                          : _vm.reset(false)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.button1) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.textOnly
                ? _c(
                    "div",
                    { staticClass: "px-3 pb-3" },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }